import { AsyncThunkBaseConfig, createAsyncThunk } from '@/redux/createAsyncThunk';
import {
    ExtendQuoteByCatalogIdParams,
    ExtendQuoteByInvoiceIdParams,
    PostExtendQuoteResponse,
} from './extendQuote.types';
import { getAuthToken } from '../user';
import { getDeployment } from '../config';
import { postExtendCatalogQuote, postExtendInvoiceQuote } from './extendQuote.api';

type ExtendQuoteAsyncThunkConfig = AsyncThunkBaseConfig & {
    rejectValue: string;
};

export const extendQuoteByInvoiceId = createAsyncThunk<
    PostExtendQuoteResponse['payload'],
    ExtendQuoteByInvoiceIdParams,
    ExtendQuoteAsyncThunkConfig
>('la/ui/extendQuote/extendQuoteByInvoiceId', async ({ invoiceId }, { getState, rejectWithValue }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    try {
        const response = await postExtendInvoiceQuote({ authToken, deployment, invoiceId });

        if (response.error) {
            throw response.payload;
        }

        return response.payload;
    } catch (error) {
        return rejectWithValue(String(error));
    }
});

export const extendQuoteByCatalogId = createAsyncThunk<
    PostExtendQuoteResponse['payload'],
    ExtendQuoteByCatalogIdParams,
    ExtendQuoteAsyncThunkConfig
>('la/ui/extendQuote/extendQuoteByCatalogId', async ({ catalogId }, { getState, rejectWithValue }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    try {
        const response = await postExtendCatalogQuote({ authToken, catalogId, deployment });

        if (response.error) {
            throw response.payload;
        }

        return response.payload;
    } catch (error) {
        return rejectWithValue(String(error));
    }
});
